import { ArrowRight, CheckCircle, ClipboardText } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";

const INCLUDES = [
  "Review of key profile information",
  "Comparison with three local competitors",
  "Identification of missing or weak content",
  "Five prioritized recommendations",
];

export const AuditOffer = () => (
  <section
    id="free-audit"
    data-testid="audit-offer-section"
    className="bg-pine-light/40 py-24 sm:py-32"
  >
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-6 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-7">
        <Reveal>
          <p className="eyebrow mb-5">Free Audit Offer</p>
          <h2 className="max-w-2xl text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
            Find Out What Your Google Maps Listing Is Missing.
          </h2>
          <p className="mt-6 max-w-xl text-base text-soot sm:text-lg">
            Request a personalized audit and we'll identify real opportunities
            to improve your Google Business Profile — before you spend a cent.
          </p>
          <ul className="mt-8 space-y-4">
            {INCLUDES.map((item, i) => (
              <li key={i} className="flex items-center gap-3">
                <CheckCircle
                  size={24}
                  weight="fill"
                  className="shrink-0 text-pine"
                />
                <span className="font-heading text-lg font-bold text-ink">
                  {item}
                </span>
              </li>
            ))}
          </ul>
          <p className="mt-6 text-sm font-medium text-soot">
            No obligation to purchase.
          </p>
          <button
            data-testid="audit-offer-cta-button"
            onClick={() => scrollToId("#audit-form")}
            className="btn-primary mt-8"
          >
            Request My Free Audit
            <ArrowRight weight="bold" size={18} />
          </button>
        </Reveal>
      </div>
      <div className="lg:col-span-5">
        <Reveal delay={0.15}>
          <div
            data-testid="audit-preview-card"
            className="card-surface rotate-1 p-8 transition-transform duration-500 hover:rotate-0 sm:p-10"
          >
            <div className="flex items-center gap-3">
              <ClipboardText size={28} weight="duotone" className="text-pine" />
              <p className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-soot">
                Your audit summary
              </p>
            </div>
            <div className="mt-7 space-y-4">
              {[
                { label: "Profile completeness", w: "w-3/5" },
                { label: "Service descriptions", w: "w-2/5" },
                { label: "Photos & posts", w: "w-1/2" },
                { label: "Vs. local competitors", w: "w-2/3" },
              ].map((row, i) => (
                <div key={i}>
                  <div className="flex items-center justify-between text-sm font-medium text-soot">
                    <span>{row.label}</span>
                  </div>
                  <div className="mt-2 h-2.5 w-full rounded-full bg-pine-soft">
                    <div className={`h-full ${row.w} rounded-full bg-pine`} />
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-7 rounded-2xl bg-pine-light p-4 text-sm font-medium text-pine">
              5 prioritized recommendations, written for your business — not a
              generic checklist.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
